import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, theme, Button } from "antd";
import { useForm, Controller } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  Row,
  Form,
  Input,
  Col,
  Typography,
} from "antd";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import ProductApi from "../../common/Apis/ProductApi";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import StorageListApi from "../../common/Apis/StorageListApi";
import AllergensApi from "../../common/Apis/AllergensApi";
const ViewSingleProduct = () => {
  const { Title } = Typography;
  let navigate = useNavigate();
  const FormData = require("form-data");
  const [formAdd] = Form.useForm();
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitSuccessful },
  } = useForm();

  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");


  const { Content } = Layout;
  const [Product, setProducts] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const getProduct = useCallback(() => {
    ProductApi.SingleProducts(id)
      .then((response) => {
        console.log(response)
        formAdd.setFieldsValue({
          productName: response.payload?.productName,
          productCode: response.payload?.productCode,
          institutionDTO: response.payload?.institutionDTO?.institutionName,
          costPriceUoM1: response.payload?.costPriceUoM1,
          sellingPriceUoM1: response.payload?.sellingPriceUoM1,
          unitUomOne: (response.payload?.unitUomOne) ? response.payload?.unitUomOne : 'N/A',
          costPriceUoM2: response.payload?.costPriceUoM2,
          sellingPriceUoM2: response.payload?.sellingPriceUoM2,
          unitUomTwo: (response.payload?.unitUomTwo) ? response.payload?.unitUomTwo : 'N/A',
          currency: response.payload?.currency,
          currency: response.payload?.currency,
          unitOfMeasurement1: response.payload?.unitOfMeasurement1,
          unitOfMeasurement2: response.payload?.unitOfMeasurement2,
          shelfLifeDTO: response.payload?.shelfLifeDTO?.description,
          coolingShelfLifeDTO: response.payload?.coolingShelfLifeDTO?.description,
          allergens: response.payload?.allergens,
          storageSuggestionDTO: response.payload?.storageSuggestionDTO?.description,


          // currency: Product?.currency,
          unitOfMeasurement1: response.payload?.unitOfMeasurement1,
          expiryDate: dayjs(response.payload?.expiryDate),
          unitOfMeasurement2: response.payload?.unitOfMeasurement2,
          costPriceUoM2: response.payload?.costPriceUoM2,
          sellingPriceUoM2: response.payload?.sellingPriceUoM2,
          institutionId: response.payload?.institutionDTO?.id,
          ShelfLifeID: response.payload?.shelfLifeDTO?.id,
          CoolingShelfLifeID: response.payload?.coolingShelfLifeDTO?.id,
          StorageID: response.payload?.storageSuggestionDTO?.id,
          supplierId: response.payload?.supplierDTO?.map(item => item.id),
          createDate: dayjs(response.payload?.productCreateDate),
          OUBD: dayjs(parseInt(response.payload?.openUBD)),
          Allergen: response.payload?.allergensDTO?.id,
        });
        setProducts(response.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  const [Sensors, setSensors] = React.useState([]);
  const getSensores = useCallback(() => {
    StorageListApi.ListStorage()
      .then((response) => {
        console.log(response);
        setSensors(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);



  useEffect(() => {
    getProduct();
    PageLoading();
    getSensores();
  }, [getProduct, PageLoading, getSensores]);


  const handleGoBack = () => {
    navigate(-1);
  };

  function formatDate(date) {
    const dateNew = parseInt(date, 10);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = new Date(dateNew).toLocaleDateString(
      "en-US",
      options
    );

    const [month, day, year] = formattedDate.split(" ");
    const capitalizedMonth = month.toUpperCase();
    return `${day} ${capitalizedMonth} ${year}`;
  }
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            form={formAdd}
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Product Name</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.productName}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Product Code</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.productCode}</h6>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Created Date</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">
                    : &nbsp;{" "}
                    {Product?.productCreateDate
                      ? formatDate(Product?.productCreateDate)
                      : ""}
                  </h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Currency</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.currency}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Unit UOM 1</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.unitUomOne}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Unit UOM 2</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.unitUomTwo}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Unit UOM 3</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.unitUomThree}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Unit of Measurement 1</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">
                    : &nbsp;{Product?.unitOfMeasurement1}
                  </h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Unit of Measurement 2</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">
                    : &nbsp; {Product?.unitOfMeasurement2}
                  </h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Unit of Measurement 3</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">
                    : &nbsp; {Product?.unitOfMeasurement3}
                  </h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Cost Price per UoM 1</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.currency} {Product?.costPriceUoM1}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Cost Price per UoM 2</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.currency} {Product?.costPriceUoM2}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Cost Price per UoM 3</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.currency} {Product?.costPriceUoM3}</h6>
                </Col>
              </Row>

              {/* <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Selling Price UoM 1</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">
                    : &nbsp; {Product?.currency} {Product?.sellingPriceUoM1}
                  </h6>
                </Col>
              </Row> */}

              {/* <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Selling Price UoM 2</b> <br />
                  </h6>
                </Col>
                <Col span={8}>
                  <h6 className="pt-3">
                    : &nbsp; {Product?.currency} {Product?.sellingPriceUoM2}
                  </h6>
                </Col>
              </Row> */}
              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Supplier</b> <br />
                  </h6>
                </Col>
                <Col span={13}>
                  <h6 className="pt-3">: &nbsp; {Product?.supplierDTO?.map(item => item?.supplierName)?.join(',')}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Department</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp; {Product?.institutionDTO?.institutionName}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Allergens</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">:
                    &nbsp;   {(Product && Product.allergens) ?
                      Product.allergens.map((allergen, index) => (
                        <React.Fragment key={allergen.id}>
                          {index > 0 && ', '}
                          {allergen.allergensName}
                        </React.Fragment>
                      ))
                      : ''}
                  </h6>


                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Shelf Life</b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp;{Product?.shelfLifeDTO?.description}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Cooling Shelf Life</b> <br />
                  </h6>
                </Col>
                <Col span={13}>
                  <h6 className="pt-3">: &nbsp;{Product?.coolingShelfLifeDTO?.description}</h6>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Storage Suggestions
                    </b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp;{Product?.storageSuggestionDTO?.name}</h6>
                </Col>
              </Row>

               <Row gutter={16}>
                <Col span={11}>
                  <h6 className="pt-3">
                    <b>Storage
                    </b> <br />
                  </h6>
                </Col>
                <Col span={10}>
                  <h6 className="pt-3">: &nbsp;{Product?.storageDTO?.name}</h6>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default ViewSingleProduct;
